import { Link } from 'react-router-dom';
import type { AnimeItem } from '@/mocks/anime';

export default function AnimeCard({ item }: { item: AnimeItem }) {
  return (
    <article className="group overflow-hidden rounded-lg bg-background-100">
      <Link to={`/category/${item.category}`} aria-label={`查看《${item.title}》详情`}>
        <div className="relative aspect-[3/4] w-full overflow-hidden">
          <img
            src={item.image}
            alt={`${item.title} 动漫封面`}
            title={`${item.title} - 动漫网`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent" />
          <span className="absolute left-2 top-2 rounded-full bg-primary-500 px-2 py-0.5 text-xs font-medium text-background-50">
            {item.status}
          </span>
          <div className="absolute bottom-2 right-2 flex items-center gap-1 rounded-full bg-foreground-950/60 px-2 py-0.5 text-xs text-secondary-300">
            <i className="ri-star-fill text-secondary-400" aria-hidden="true" />
            {item.rating}
          </div>
          <div className="absolute inset-x-0 bottom-0 p-3">
            <h3 className="font-heading text-lg text-background-50 leading-tight">{item.title}</h3>
          </div>
        </div>
      </Link>
      <div className="flex flex-wrap items-center gap-1.5 px-3 py-3">
        {item.tags.map((t) => (
          <span key={t} className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
            {t}
          </span>
        ))}
      </div>
    </article>
  );
}